import { defineComponent as _defineComponent } from 'vue'
import { onMounted, Ref, ref } from 'vue';
import { GoToHomePage, GoToRecentTaskGroup } from '../../util/UrlUtil';
import { Breadcrumb } from './Breadcrumb';
import Resource from '../../src/resources/Resource.vue';
import { Resources } from '../../src/resources/Resources';


    
export default /*#__PURE__*/_defineComponent({
  __name: 'BreadcrumbsApp',
  setup(__props, { expose }) {
  expose();

const thisPath = window.location.pathname;
    let breadcrumbs: Ref<Breadcrumb[]> = ref([]);
    
onMounted(async () => {
    Resources.GetInstance()
        .then((res) => {
            // TODO this sucks
            let home = res.GetResource("home_title");
            let taskList = res.GetResource("tasklist_title");
            let taskHistory = res.GetResource("taskhistory_title");
            let task = res.GetResource("task_title");

            if(thisPath == "/" || thisPath == "/Home")
                breadcrumbs.value = [new Breadcrumb(home, GoToHomePage, true)];
            else if(thisPath == "/Home/Tasks")
                breadcrumbs.value = [new Breadcrumb(home, GoToHomePage), new Breadcrumb(taskList, GoToRecentTaskGroup, true)];
            else if(thisPath == "/Home/TaskHistory")
                breadcrumbs.value = [new Breadcrumb(home, GoToHomePage), new Breadcrumb(taskHistory, GoToRecentTaskGroup, true)];
            else if(thisPath == "/PortalTask")
                breadcrumbs.value = [new Breadcrumb(home, GoToHomePage), new Breadcrumb(taskList, GoToRecentTaskGroup), new Breadcrumb(task, () => {}, true)];
        });

    
});

const __returned__ = { thisPath, breadcrumbs }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})